var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 5L7.42748 8.26414C9.55129 9.4675 10.4486 9.4675 12.5725 8.26414L18.3333 5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67977 11.2297C1.73424 13.7844 1.76148 15.0616 2.70409 16.0079C3.64669 16.954 4.95857 16.9869 7.58232 17.0529C9.19938 17.0935 10.8005 17.0935 12.4176 17.0529C15.0414 16.9869 16.3532 16.954 17.2959 16.0079C18.2385 15.0616 18.2657 13.7844 18.3201 11.2297C18.3377 10.4083 18.3377 9.59177 18.3201 8.77035C18.2657 6.21574 18.2385 4.93843 17.2959 3.99224C16.3532 3.04605 15.0414 3.01309 12.4176 2.94716C10.8005 2.90653 9.19938 2.90653 7.58231 2.94715C4.95857 3.01307 3.64669 3.04603 2.70408 3.99223C1.76148 4.93842 1.73424 6.21573 1.67976 8.77035C1.66224 9.59177 1.66225 10.4083 1.67977 11.2297Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.29db13f7a91184ef80da517b99b81e5f.svg";
export { ForwardRef as ReactComponent };